import { EDirection, EMediaQuery } from 'src/styles/theme/utils/enums';
import { addHiddenRangesStyles, addTransition, mq } from 'src/styles/theme/utils/functions';
import styled, { css } from 'styled-components';

export const StyledArrowContainer = styled.div<{
	direction: EDirection;
	isDisabled?: boolean;
	isHidden?: boolean;
	arrowClassName?: string;
}>`
	${(p) => css`
		position: absolute;
		z-index: 100;

		height: 53px;
		width: 30px;

		top: calc((100% - 106px - 53px) / 2);

		${addTransition(undefined, 0.2)}

		${p.isDisabled
			? css`
					opacity: 0.2;

					& > button {
						cursor: default;
					}
			  `
			: css`
					@media (hover: hover) {
						&:hover {
							opacity: 0.5;
						}
					}
			  `}


		${p.isHidden
			? css`
					opacity: 0;
					pointer-events: none;
					@media (hover: hover) {
						&:hover {
							opacity: 0;
						}
					}
			  `
			: ``}


		${mq(
			EMediaQuery.lg,
			`${p.direction === EDirection.left ? `left: -48px;` : p.direction === EDirection.right ? `right: -48px;` : ''}`,
			'min'
		)}

		${p.direction === EDirection.left
			? `left: -48px; transform: rotate(180deg);`
			: p.direction === EDirection.right
			? `right: -48px;`
			: ''}

		${addHiddenRangesStyles(p)}
	`}
`;

export const StyledArrowImage = styled.img`
	height: 100%;
	width: 100%;
`;
